import { pctChange } from './k2utils';

const qtyFmt = new Intl.NumberFormat('cs-CZ', { maximumFractionDigits: 2 });
export const fmtQty = (v, unit) => `${qtyFmt.format(v || 0)}${unit ? ` ${unit}` : ''}`;

const empty = (x) => ({
  code: x.article_code, name: x.article_name, unit: x.unit, lines: [], docs: new Set(),
  wq: 0, wv: 0, sq: 0, sv: 0, q290: 0, v290: 0, q291: 0, v291: 0, prevQ: 0, prevV: 0,
  wq290: 0, wv290: 0, wq291: 0, wv291: 0,
});

// Aggregates item lines per article: written-off (positive), surplus (negative), net, per book, previous net
export function aggregateItems(items, range, withPrev) {
  const map = new Map();
  items.forEach((x) => {
    const isCur = x.date >= range.from && x.date <= range.to;
    const isPrev = withPrev && x.date >= range.prevFrom && x.date <= range.prevTo;
    if (!isCur && !isPrev) return;
    const key = x.article_code || x.article_name;
    if (!map.has(key)) map.set(key, empty(x));
    const a = map.get(key);
    if (isPrev) { a.prevQ += x.quantity; a.prevV += x.value; return; }
    a.lines.push(x);
    a.docs.add(x.doc_rid);
    if (x.quantity >= 0) {
      a.wq += x.quantity; a.wv += x.value;
      if (x.book === '290') { a.wq290 += x.quantity; a.wv290 += x.value; } else { a.wq291 += x.quantity; a.wv291 += x.value; }
    } else { a.sq += -x.quantity; a.sv += -x.value; }
    if (x.book === '290') { a.q290 += x.quantity; a.v290 += x.value; } else { a.q291 += x.quantity; a.v291 += x.value; }
  });
  return [...map.values()]
    .filter((a) => a.lines.length > 0)
    .map((a) => ({
      ...a, nq: a.wq - a.sq, nv: a.wv - a.sv, docCount: a.docs.size,
      deltaQ: pctChange(a.wq - a.sq, a.prevQ), deltaV: pctChange(a.wv - a.sv, a.prevV),
    }));
}
